var _linearGradient, _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShelly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 48,
    x2: 0,
    y1: 24,
    y2: 24
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#154061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#347db6"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 48,
    rx: 8,
    width: 48
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#262f30",
    height: 48,
    rx: 8,
    width: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.3682 21.162.6705-1.4505h-.891s-.3264 0-.3705 0c-.5734 0-.8557.2576-.8557.773 0 .2672.1676.8493.5028 1.7655.3353.9161.5029 1.6318.5029 2.1567 0 1.107-.5646 1.9468-1.7026 2.5003-.8469.4104-1.83487.6108-2.97285.6108-1.04094 0-1.95838-.1527-2.76114-.4676-1.12916-.439-1.69373-1.107-1.69373-2.0232 0-1.3169 1.04094-1.985 3.12282-1.985h2.14363.5734c-.07939.315-.25582.5535-.53811.7349-.24701.1622-.53812.2385-.85569.2385h-.22054-.21172c-.42343 0-.78511.0764-1.09387.2386-.40579.21-.60868.5154-.60868.9162 0 .458.28229.8207.83804 1.0784.43226.2004.89098.2958 1.38498.2958.61751 0 1.13798-.1432 1.55259-.4485.48517-.3436.72337-.8303.72337-1.4697 0-.439-.15-1.0688-.4587-1.88-.30877-.8207-.45874-1.4506-.45874-1.9086 0-1.4315 1.08504-2.1663 3.26394-2.2141h.2206.3881.2911c.5293 0 .988.0859 1.3938.2577.5293.2386.8116.5917.8381 1.0688.0176.4772-.1941.878-.644 1.2025h-2.0731zm29.4287 5.0102c-.2206.6585-.644.9925-1.2615.9925h-1.3938c-.3352.9734-.6793 1.6987-1.0498 2.1663-.5116.6489-1.1468.983-1.9054.983-.4764 0-.8469-.1527-1.1027-.4486-.2294-.2672-.3352-.6012-.3352-1.0211 0-.334.0617-.6489.194-.9639.1324-.3053.3088-.5439.5205-.7157h-.4499c-.247 0-.4587-.0859-.6263-.2481-.0353.0191-.0706.0381-.1059.0572-.2382.1241-.5028.1909-.7763.1909h-2.2054c-.3528 0-.591-.0859-.7233-.2481-.0353.0191-.0706.0381-.1059.0572-.2382.1241-.494.2004-.7763.2004h-12.2619c-.4234 0-.6352-.1622-.6352-.4962 0-.1336.0265-.2863.0883-.4772l.4058-1.2978-2.126 1.8991c-.2647.2481-.5381.3721-.8293.3721h-1.1556l2.4083-7.3482h2.0201l-1.6937 5.1724 1.5261-1.3551c.4411-.3913.9439-.5917 1.5085-.5917.3705 0 .7498.0954.7498.5153 0 .1527-.1058.4676-.1764.668l-.6351 1.9755h1.9319c-.1235-.2291-.1853-.4963-.1853-.8112 0-.7634.3088-1.3551.9351-1.7941.5381-.3722 1.1733-.5631 1.9143-.5631h.8116c.4763 0 .8909.0764 1.2526.2386.4764.21.7322.5344.7498.9639.0177.4294-.1499.8398-.5822 1.0784-.4675.2672-1.9495.8779-1.9495.8779l.7321-2.1854h-1.2261l-.4588 1.4697c-.0264.0859-.0353.1622-.0353.229 0 .3245.2471.4963.7322.4963h.2559 2.9464c0-.0096 0-.0191.0088-.0382l2.0819-6.3367h2.0289l-2.0995 6.3367h1.7908l2.073-6.3367h2.029l-2.0907 6.3367h1.6143c.0088-.0763.0176-.1622.0529-.2386l.9704-2.8916h2.0819l-1.0586 3.1302h1.1644l1.0233-3.1302h2.0643l-1.0145 3.1302zm-4.7989 1.1643c-.2559 0-.4852.1527-.7058.458-.2205.3054-.3264.6108-.3264.9162 0 .2768.1147.4867.3353.6585z",
    fill: "#fffffb"
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.6855 18.8535c.0013-.0187.002-.0376.002-.0566 0-.4401-.3568-.7969-.7969-.7969-.3671 0-.6763.2483-.7687.5862-.0536-.0154-.1102-.0237-.1688-.0237-.3365 0-.6093.2728-.6093.6094 0 .3365.2728.6093.6093.6093.0158 0 .0314-.0005.0469-.0017v.0017h1.7812c.2589 0 .4688-.2098.4688-.4687s-.2099-.4687-.4688-.4687c-.0328 0-.0648.0033-.0957.0097z",
    fill: "#96b7db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.7758 19.6721c.0089-.0635.0136-.1283.0136-.1943 0-.7644-.6197-1.384-1.3841-1.384-.6622 0-1.2158.465-1.3519 1.0863-.0593-.0103-.1203-.0156-.1825-.0156-.5845 0-1.0584.4738-1.0584 1.0583 0 .5846.4739 1.0584 1.0584 1.0584.0273 0 .0544-.001.0812-.003v.003h2.9973.0029.0029.0907v-.0053c.4055-.0464.7205-.3908.7205-.8088 0-.4496-.3645-.8141-.8141-.8141-.0606 0-.1197.0066-.1765.0191z",
    fill: "#4688bf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShelly);
export default __webpack_public_path__ + "static/media/shelly.caa3c7533ea92d11bff528ccf99d4eb5.svg";
export { ForwardRef as ReactComponent };